import { createPortal } from "react-dom";
import Button from "./form/Button";
import { ReactSVG } from "react-svg";
import error from "../assets/svgs/error.svg";
import Session from "../utils/sessionStorage";

const ErrorModal = ({ close, message, title = "Error!" }) => {

    const userSession = Session.get("_user_");
    const userData = userSession ? JSON.parse(userSession) : {};
    const saOrgName = userData?.saOrgName;

    const handleOk = () => {
        if (message === "Unauthenticated.") {
            Session.clear();
            window.location.href = `https://uat.onepay.com.my/dl/${saOrgName}/?OpName=Close`;
        } else {
            close();
        }
    };

    return createPortal(
        <div className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 flex justify-center items-center h-full w-full md:inset-0 max-h-full bg-black bg-opacity-50">
            <div className="p-4 w-full max-w-md max-h-full">
                <div className="px-7 py-6 bg-white rounded-3xl shadow">
                    <div>
                        {/* Error Icon */}
                        <div className="flex justify-center mb-4">
                            <ReactSVG src={error} />
                        </div>

                        {/* Title */}
                        <h2 className="text-[17px] font-semibold text-center mb-2">
                            {title}
                        </h2>

                        {/* Message */}
                        <p className="text-[15px] text-center text-gray mb-6">
                            {message}
                        </p>

                        {/* OK Button */}
                        <div className="flex gap-2 justify-center">
                            <Button
                                children={"OK"}
                                intent={"primary"}
                                size={"md"}
                                roundness={"round"}
                                eventAction={handleOk}
                                classes={"flex-1 h-10 text-[12px] font-normal"}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ErrorModal;
